import { Component, ViewChild } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';
import { AssetProductCategoryLovComponent } from '../asset-product-category-lov/asset-product-category-lov.component';
import { AssetProductService } from '../../services/asset-product-service';
import { Field } from 'src/app/tools/models/dtos/field';


@Component({
  selector: 'asset-product-list',
  templateUrl: './asset-product-list.component.html',
  styleUrls: ['./asset-product-list.component.scss']
})

export class AssetProductListComponent extends BasePage2<AssetProduct> {
 
  // Filter fields
  // ---------------------------------------------------
  code      : string;
  equipment : boolean = true;
  spares    : boolean = false;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  assetProducts: AssetProduct[] = [];
  // ---------------------------------------------------
  
  // ---------------------------------------------------

  constructor(
    protected assetProductService     : AssetProductService,
      protected toastr                : ToastrService,
      protected router                : Router,
      protected baseService           : BaseService,
      protected leanUtilsService      : LeanUtilsService,
      protected controlTablesService  : ControlTablesService,
      protected location              : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName =  "assetProduct";
  }
  // ---------------------------------------------------


  
// ---------------------------------------------------------------------
  ngAfterViewInit(){
    super.ngAfterViewInit();
    this.loadData();
}
// ---------------------------------------------------------------------

 
  // ---------------------------------------------------
  getRows(): AssetProduct[] {
      return this.assetProducts;
  }
  // ---------------------------------------------------


//----------------------------------------------------------------------
saveRow(row: AssetProduct): Promise<AssetProduct> {
  return this.assetProductService.assetProductSave(row);
}
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
  new(){
      let entity : AssetProduct = new AssetProduct();
      entity.inserted = true;
      entity.edit = true;
      this.assetProducts.push(entity);
      this.assetProducts = [...this.assetProducts];
    }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  loadData() {
    this.assetProductService.assetProductsGet(this.code, this.equipment, this.spares).then(result => {
        this.assetProducts = result;
    })
  }
// ---------------------------------------------------

//----------------------------------------------------------------------
enrichField(field : Field){
    if (field.prop == 'assetProductCategory.name') {
        field.modal = AssetProductCategoryLovComponent
    }
  }
//----------------------------------------------------------------------


}